import { render, staticRenderFns } from "./RoofLayout.vue?vue&type=template&id=4412d72e"
import script from "./RoofLayout.vue?vue&type=script&lang=js"
export * from "./RoofLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports